<template>

    <div class="jobcard  transitionStyle" v-if="datas">
        <div class="flexBetween">
            <div class="jobcard-left" @click.stop="gotoJob(datas.positionId)">
                <div class="flex jobcard-title">
                    <p>{{datas.positionName}}</p>
                    <p>{{datas.salaryRangeName}}</p>
                    <div class="collect"  v-if="type==='collect'"
                         @click.stop="collectJob(datas.positionId)"> 
                        <span class="fonticon">&#xe623;</span> 
                        取消收藏
                    </div>
                </div>
                <Btns :value="datas.workExperienceName"></Btns>
                <Btns :value="datas.qualificationsName"></Btns>
                <Btns v-if="datas.jobRecruiters" :types="2" :value="datas.jobRecruiters"></Btns>
            </div>
            <div class="flexColumn jobcard-right" @click.stop="gotoCompany(datas.companyId)">
                <p>{{datas.companyName}}</p>
                <p> 
                    <span>{{datas.companyTypeName}}</span> 
                    <el-divider direction="vertical"></el-divider> 
                    <span>{{datas.scaleName}}</span> 
                </p>
                <p>{{datas.updatedTime}} 更新</p>
            </div>
        </div>
        <div v-if="datas.address" class="jobcard-address">{{datas.address}}</div>
    </div>
  </template>
  
  <script>

 import Btns from '../../../components/Btn.vue';
 import {mapActions} from 'vuex'
  export default {
    props: {
        datas:{
            type:Object,
            default:()=>{}
        },
        type:{
            type:String,
            default:''
        }
    },
    data() {
      return {};
    },
    components: {Btns},
    methods: {
        ...mapActions([
        "deleteFavorite",
          
        ]),
        gotoJob(id){
            this.$router.push({ path:`/job/detail?id=${id}`})
        },
        gotoCompany(id){
            this.$router.push({path:`/company/detail?id=${id}`})
        },
        async collectJob(id){
        const res = await this.deleteFavorite(id);
          if (res) {
            this.$message({
              message: "取消收藏!",
              type: "success"
            });
            this.$emit('refreshData')
          }else {
            this.$message({
              message: res.message,
              type: "warning"
            });
          }
        }
    }
  };
  </script>
  
  <style lang="scss" scoped>
    $mianColor:#287CF3;
    $whiteColor:#fff;
    $fontCol:rgba(0,0,0,0.85);
    $secondfontCol:rgba(0,0,0,0.5);
    $yellowColor:#FF8A16;
    .jobcard{
        background: #FFFFFF;
        border-radius: 6px;
        border: 1px solid #D3D6DB;
        margin-top: 16px;
        margin-bottom: 10px;
        padding: 20px;
        cursor: pointer;
        &:hover{
            box-shadow: 0 16px 40px 0 hsla(0, 0%, 60%, 0.3);
        }
        &-title{
            p{
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: $fontCol;
                line-height: 22px;
                padding-right: 10px;
                padding-bottom: 10px;
                &:last-child{
                    font-weight: 600;
                    color: #FF8A16;
                }
            }
            .collect{
                height: 24px;
                line-height: 24px;
                border-radius: 12px;
                padding: 0 10px;
                border: 1px solid #287CF3;
                margin-left: 10px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color:  #287CF3;
                cursor: pointer;
            .fonticon{
                padding-right: 4px;
            }
                    }
        }
        &-right{
            align-items: flex-end;
            p{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: $fontCol;
                line-height: 20px; 
                span{
                    font-size: 12px;
                }
                &:last-child{
                    font-size: 12px;
                    color: $secondfontCol;
                }
            }
        }
        &-address{
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.65);
            line-height: 20px;
        }
    }
    

  </style>
  